import { useProductDetails } from '../../../hooks/product/useProductDetails';
export const useIncludedHubSpotCredits = ({
  productApiName
}) => {
  var _hubSpotCreditsPackag;
  const {
    productDetails,
    loading
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const hubSpotCreditsPackage = packagedQuantities === null || packagedQuantities === void 0 ? void 0 : packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'HUBSPOT_CREDITS');
  const includedHubSpotCredits = (_hubSpotCreditsPackag = hubSpotCreditsPackage === null || hubSpotCreditsPackage === void 0 ? void 0 : hubSpotCreditsPackage.quantity) !== null && _hubSpotCreditsPackag !== void 0 ? _hubSpotCreditsPackag : null;
  return {
    includedHubSpotCredits,
    loading
  };
};